import React from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  return <section className="py-24 px-4 bg-black" data-id="element-175">
      <div className="max-w-3xl mx-auto" data-id="element-176">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-177">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-178">
            Does this sound familiar?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed bg-dark-card p-6 rounded-2xl border border-dark-border" data-id="element-179">
            Sunday night. 10 PM. Tomorrow morning you have a yoga class to
            teach. And you are still sitting there, searching online, trying to
            build a sequence that actually flows — that fits your students, that
            feels professional, that does not feel like you put it together in
            twenty minutes.
            <br data-id="element-180" />
            <br data-id="element-181" />
            <span className="text-gold-light font-medium" data-id="element-182">
              Not because you do not know yoga.
            </span>{' '}
            Because no one ever gave you a complete, ready-to-teach library. You
            have been building every single class from scratch. The time you
            should be resting — you are spending planning. And the worst part is
            not the exhaustion. The worst part is walking into the studio
            feeling like you could have been more prepared.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-6" data-id="element-183">
          <h3 className="text-xl font-bold text-white mb-8 text-center" data-id="element-184">
            The real cost of not having the right resource:
          </h3>

          <ul className="space-y-4" data-id="element-185">
            {['Nights lost searching for sequences that work, flow, and fit your specific students', 'Classes that feel repetitive — because you keep falling back on what you already know', 'Visible improvisation that quietly chips away at your confidence as a teacher', 'No variety across weeks — and students who slowly lose motivation without knowing why', 'Weekends spent planning instead of resting, recovering, or living your life'].map((point, i) => <motion.li key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 bg-dark-card p-4 rounded-xl border border-red-900/30" data-id="element-186">
                <span className="text-red-500 mt-1" data-id="element-187">🔴</span>
                <span className="text-gray-300" data-id="element-188">{point}</span>
              </motion.li>)}
          </ul>

          <div className="text-center mt-12 pt-8 border-t border-dark-border" data-id="element-189">
            <p className="text-2xl font-serif font-bold text-gold-gradient" data-id="element-190">
              Stop giving away your free time. Your dedication is already there.
              What you need now is the right tool.
            </p>
            <p className="text-xl mt-4 text-white" data-id="element-191">
              Plan more than 40 weeks of classes today.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}